import React from "react";
import { Col, Container, Row } from "react-bootstrap";

function Advantagecloud() {
  return (
    <section
      className="advantage_cloud p-100 it_staff_choose"
      style={{ background: "#F9F9F9" }}
    >
      <Container>
        <Row>
          <Col
            xs={12}
            md={9}
            lg={8}
            xl={8}
            xxl={8}
            className="m-auto text-center"
          >
            <h2>Why Choose TekRevol as Your IT Staff Augmentation Company?</h2>
          </Col>
        </Row>
        <Row className="mt-4">
          <Col xs={12} md={12} lg={12} xl={12} xxl={12} className="m-auto">
            <Row>
              <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
                <div className="advantage_box">
                  <div className="advantage_content">
                    <h5>
                      Enhance Communication
                      <br /> Efficiency
                    </h5>
                    <p>
                      Our developers align with your time zone and work hours,
                      ensuring seamless integration and effective communication.
                      They are trained to provide clear, concise feedback and
                      adapt quickly to your team dynamics.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
                <div className="advantage_box">
                  <div className="advantage_content">
                    <h5>
                      Accelerate
                      <br /> Recruitment
                    </h5>
                    <p>
                      Avoid the delays associated with traditional hiring
                      processes. TekRevol assembles and onboards your team of
                      experts in record time, allowing you to start your
                      projects without unnecessary delays.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
                <div className="advantage_box">
                  <div className="advantage_content">
                    <h5>
                      Build Strong,
                      <br /> Cohesive Teams
                    </h5>
                    <p>
                      We evaluate developers on their soft skills and cultural
                      fit to ensure they integrate smoothly into your team. This
                      results in a harmonious work environment and positive
                      collaboration.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
                <div className="advantage_box">
                  <div className="advantage_content">
                    <h5>
                      Ongoing
                      <br /> Support
                    </h5>
                    <p>
                      We provide continuous support and management to ensure our
                      professionals meet your expectations and deliver
                      consistent performance. This includes regular check-ins,
                      performance reviews, and proactive issue resolution.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
                <div className="advantage_box">
                  <div className="advantage_content">
                    <h5>
                      Advanced Project
                      <br />
                      Management
                    </h5>
                    <p>
                      Benefit from advanced project management practices that
                      keep your projects on track. Our professionals are skilled
                      in Agile, Scrum, and other methodologies to ensure timely
                      delivery and high-quality results.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
                <div className="advantage_box">
                  <div className="advantage_content">
                    <h5>
                      Risk
                      <br /> Mitigation
                    </h5>
                    <p>
                      Reduce project risks with our staff augmentation services
                      and augment your team with experienced professionals who
                      bring best practices and proven methodologies to your
                      projects, minimizing the chances of errors and setbacks.
                    </p>
                  </div>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Advantagecloud;
